import { useEffect } from "react";
import { isTestRealm, setTestRealm } from "@/utils/country";

export const useTestRealm = () => {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const testRealmParam = urlParams.get("test-realm");

    if (testRealmParam === "true") {
      // Set localStorage to true
      setTestRealm(true);

      // Remove the query parameter from URL
      urlParams.delete("test-realm");
      const newUrl = urlParams.toString()
        ? `${window.location.pathname}?${urlParams.toString()}`
        : window.location.pathname;

      // Update URL without the parameter and refresh
      window.history.replaceState({}, "", newUrl);
      window.location.reload();
    }
  }, []);

  return isTestRealm();
};
